<template>
  <v-card class="rounded-lg white">
    <v-card-title>خلاصه محصولات شریک</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5" lg="4">
          <PartnerSelect v-model="partnerId" label="انتخاب شریک" placeholder="یک شریک را انتخاب کنید" clearable />
        </v-col>
      </v-row>

      <div v-if="!partnerId" class="text-center py-12 grey--text">
        برای دیدن خلاصه محصولات، یک شریک را انتخاب کنید.
      </div>

      <div v-else class="admin-dark-panel rounded-lg pa-3 mt-2">
        <PartnerCalculations :key="partnerId" :partner-id="partnerId" @select-product="goToProduct" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartnerSelect from "@/components/selects/PartnerSelect"
import PartnerCalculations from "./PartnerCalculations"
import adminPartnerSelection from "./adminPartnerSelectionMixin"

export default {
  name: 'AdminPartnerCalculationsProducts',

  mixins: [adminPartnerSelection],

  components: { PartnerSelect, PartnerCalculations },

  methods: {
    goToProduct(productId) {
      this.$router.push({ name: 'AdminPartnerCalculationsProductDetailPage', params: { productId } })
    },
  },
}
</script>

<style scoped>
.admin-dark-panel {
  background-color: #111827;
}
</style>
